/**
 * Curated sidequest title pool for the Sidequest Author editor (Variant B).
 * The Author scene's name field defaults to cycling this list with ←/→ ; a
 * physical-keyboard a–z/0–9 keypress flips that field into free-text mode for
 * the rest of the edit.
 *
 * Aesthetic: dark-fantasy, ≤18 chars (matches the banner+overlay budget),
 * Title Case, no leading articles. Hand-tuned so adjacent picks read varied.
 */
export const SIDEQUEST_NAME_POOL: readonly string[] = [
  "Mossy Hollow",
  "Frozen Spire",
  "Sablefen Vigil",
  "Brassbound Reliquary",
  "Ravenkin Crypt",
  "Hollow Throne",
  "Wraithlit Causeway",
  "Pithwood Chapel",
  "Candlelit Reach",
  "Greylock Ford",
  "Ashfall Gallows",
  "Tideworn Bell",
  "Dusky Cradle",
  "Verdant Lantern",
  "Ember Keep",
  "Stormstruck Ford",
  "Marrow Reliquary",
  "Snailcairn Pass",
  "Owlclasp Hollow",
  "Hushmoon Vigil",
  "Bramble Causeway",
  "Junipernox Gate",
  "Wickerwax Cradle",
  "Saltcobble Chapel",
  "Glimmersaw Bell",
  "Smokecreek Vow",
  "Earlybell Mire",
  "Foxglove Span",
  "Quietfern Pass",
  "Hollowmint Throne",
] as const;
